export interface PWAStatus {
  isInstalled: boolean;
  displayMode: "browser" | "standalone" | "fullscreen" | "minimal-ui";
  platform: "ios" | "android" | "desktop" | "unknown";
}

export function getPWAStatus(): PWAStatus {
  const isStandalone =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.matchMedia("(display-mode: fullscreen)").matches ||
    window.matchMedia("(display-mode: minimal-ui)").matches ||
    ("standalone" in window.navigator &&
      (window.navigator as { standalone?: boolean }).standalone === true);

  let displayMode: PWAStatus["displayMode"] = "browser";
  if (window.matchMedia("(display-mode: standalone)").matches) {
    displayMode = "standalone";
  } else if (window.matchMedia("(display-mode: fullscreen)").matches) {
    displayMode = "fullscreen";
  } else if (window.matchMedia("(display-mode: minimal-ui)").matches) {
    displayMode = "minimal-ui";
  }

  const userAgent = navigator.userAgent.toLowerCase();
  let platform: PWAStatus["platform"] = "unknown";

  if (/iphone|ipad|ipod/.test(userAgent)) {
    platform = "ios";
  } else if (/android/.test(userAgent)) {
    platform = "android";
  } else if (!/mobile|tablet/.test(userAgent)) {
    platform = "desktop";
  }

  return {
    isInstalled: isStandalone,
    displayMode,
    platform,
  };
}

export function isPWAInstalled(): boolean {
  return getPWAStatus().isInstalled;
}
